import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { CLPUser } from '../../../../models/contact-modal/clpuser.model';
import { SimpleResponse } from '../../../../models/contact-modal/genericResponse.model';
import { BuzzScore, eScoreType, ScoreHistory, ScoreHistoryResponse } from '../../../../models/contact-modal/report.model';
import { GlobalService } from '../../../../services/contact-services/global.service';
import { NotificationService } from '../../../../services/contact-services/notification.service';
import { ReportService } from '../../../../services/contact-services/report.service';
import { GridConfigurationService } from '../../../../services/contact-services/shared/gridConfiguration.service';
import { LocalService } from '../../../../services/contact-services/shared/local.service';
import { UtilityService } from '../../../../services/shared/utility.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'buzz-index',
    templateUrl: './buzz-index.component.html',
    styleUrls: ['./buzz-index.component.css'],
    providers: [GridConfigurationService]
})
export class BuzzIndexComponent implements OnInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    scoreHistoryResponseSource: MatTableDataSource<any>;
    scoreHistoryResponseDisplayColumns: string[] = [];
    private encryptedUser: string = '';
    showSpinner: boolean = false;

    scoreHistoryResponse: ScoreHistory[];
    @Input() user: CLPUser;
    @Input() buzzIndexCalcModal: BuzzScore;
    @Input() scoreType: number = 0;
    @Input() startDt: string;
    @Input() endDt: string;
    dateFormat: string = "MM/dd/yyyy";
    columns = [
        { field: '$', title: '', width: '40' },
        { field: 'score', title: 'Index', width: '100' },
        { field: 'type', title: 'Type', width: '100' },
        { field: 'dtCreated', title: 'Created', width: '100' },
        { field: 'delete', title: '', width: '30' },
    ];
    reorderColumnName: string = 'score,type,dtCreated,delete';
    arrColumnWidth: any[] = ['score:100,type:100,dtCreated:100,delete:30'];
    columnWidth: string = 'score:100,type:100,dtCreated:100,delete:30';
    contactName: any;
    buzzScore: any;
    constructor(private _utilityService: UtilityService,
        public _localService: LocalService,
        private _router: Router,
        public _gridCnfgService: GridConfigurationService,
        private _reportService: ReportService,
        private _globalService: GlobalService,
        private notifyService: NotificationService,
        private datePipe: DatePipe) {

    }

    ngOnInit(): void {
        if (!isNullOrUndefined(localStorage.getItem("token"))) {
            this.encryptedUser = localStorage.getItem("token");
            if (!isNullOrUndefined(this.user)) {
                this.dateFormat = this.user.dateFormat;
                this._gridCnfgService.user = this.user;
                //Kendo grid load call stopped.
                //this.getGridConfiguration();
                this.getBuzzScoreCalculation();
            }
        }
    }

    //getGridConfiguration() {
    //    this._gridCnfgService.columns = this.columns;
    //    this._gridCnfgService.reorderColumnName = this.reorderColumnName;
    //    this._gridCnfgService.columnWidth = this.columnWidth;
    //    this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
    //    this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'buzz_score_calculation_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('buzz_score_calculation_grid').subscribe((value) => { }));
    //}

    async resetScoreHistory() {
        this.showSpinner = true;
        await this._reportService.getResetScoreHistory(this.encryptedUser, this.buzzIndexCalcModal?.contactID ?? 0)
            .then(async (result: SimpleResponse) => {
                if (result && result?.messageBool) {
                    this.getBuzzScoreCalculation();
                    this.notifyService.showSuccess("Score has been reset.", "", 3000);
                }
                else {
                    this.notifyService.showError("Some error occured", "", 3000);
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, null, 'contactID ' + this.buzzIndexCalcModal?.contactID);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    async resetSingleScore(scoreHistoryData: ScoreHistory) {
        this.showSpinner = true;
        const dtCreated = this.datePipe.transform(scoreHistoryData.dtCreated, 'MMddyyyy') ?? '';
        await this._reportService.getDeleteScoreHistory(this.encryptedUser, scoreHistoryData.contactID, this.scoreType, dtCreated)
            .then(async (result: SimpleResponse) => {
                if (result)
                    this.getBuzzScoreCalculation();
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, null, 'contactID ' + scoreHistoryData.contactID + "," + "scoreType " + this.scoreType + "," + "dtCreated " + dtCreated);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    async getBuzzScoreCalculation() {
        this.showSpinner = true;
        const startDate = this.datePipe.transform(this.startDt, 'MMddyyyy') ?? '';
        const endDate = this.datePipe.transform(this.endDt, 'MMddyyyy') ?? '';
        await this._reportService.getScoreHistoryResponse(this.encryptedUser, this.buzzIndexCalcModal?.contactID ?? 0, this.user?.cLPUserID, startDate, endDate, this.scoreType)
            .then(async (result: any) => {
                if (result) {
                    this.scoreHistoryResponse = UtilityService.clone(result?.scoreHistory);
                    this.buzzScore = this.scoreHistoryResponse?.map(s => s.score)?.reduce((a, b) => a + Number(b), 0);
                    this.contactName = result?.contactName
                    this.showSpinner = false;
                    this.setGrid(this.scoreHistoryResponse);
                }
                this.showSpinner = false;

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, null, 'buzzIndexCalcModal?.contactID ' + this.buzzIndexCalcModal?.contactID + "," + "cLPUserID " + this.user?.cLPUserID + "," + "startDate " + startDate + "," + "endDate " + endDate + "," + "scoreType " + this.scoreType);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    setTypeDisplay(value) {
        switch (value) {
            case eScoreType.Unknown:
                return 'Unknown';
            case eScoreType.Mailing_Open:
                return 'Mailing Email Opened';
            case eScoreType.Email_Click:
                return 'Email Click';
            case eScoreType.Event_FT:
                return 'Field Trigger Fired';
            case eScoreType.Event_Appt:
                return 'Appointment Completed';
            case eScoreType.Event_Email:
                return 'Email Sent';
            case eScoreType.Event_CT:
                return 'Process Trigger Fired';
            case eScoreType.Event_Task:
                return 'Task Completed';
            case eScoreType.Event_TxtMsg:
                return 'Text Message Sent';
            case eScoreType.Text_Keyword:
                return 'Text Message Keyword Processed';
            case eScoreType.Event_VoiceDrop:
                return 'Voice Mail Dropped';
            case eScoreType.Event_VoiceCall:
                return 'Outbound Call Connected';
            case eScoreType.Event_IBTxtMsg:
                return 'Text Message Received';
            case eScoreType.Event_IBVoiceCall:
                return 'Inbound Call Initiated';
            case eScoreType.Event_IBVoiceCallAnswered:
                return 'Inbound Call Answered';
        }
    }


    setGrid(list) {
     
        this.scoreHistoryResponseDisplayColumns = this.columns.map(c => c.field);

        this.scoreHistoryResponseSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.scoreHistoryResponseSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('tag_setting_grid') ? this._localService.getPageSize('tag_setting_grid'): 50;
            }
            if (this.sort) {
                this.scoreHistoryResponseSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('tag_setting_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500)

    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
